import { render } from "./StackedColumn.vue?vue&type=template&id=98aaa7a8&scoped=true"
import script from "./StackedColumn.vue?vue&type=script&lang=js"
export * from "./StackedColumn.vue?vue&type=script&lang=js"

import "./StackedColumn.vue?vue&type=style&index=0&id=98aaa7a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98aaa7a8"]])

export default __exports__